import { Avatar, Grid, Text } from '@wework/dieter-ui'
import React from 'react'

export default function MemberOverview({ selected, selectedCompany }) {
  if (!selected) return null
  const { contact_info_email, contact_info_name, contact_info_phone } = selected

  return (
    <Grid style={{ padding: 8 }}>
      {selectedCompany && (
        <Text size="small" style={{ fontWeight: 'bold' }}>
          {selectedCompany.name}
        </Text>
      )}
      <Grid.Row>
        <Grid.Column width={2}>
          <Avatar size={'tiny'} src={''} />
        </Grid.Column>
        <Grid.Column width={12}>
          <Text size={'tiny'}>{contact_info_name}</Text>
          <Text size={'tiny'}>{contact_info_phone || contact_info_email}</Text>
        </Grid.Column>
      </Grid.Row>
    </Grid>
  )
}
